import Dashboard from "../pages/admin/dashboard/Dashboard";
import Users from "../pages/admin/users/Users";
import Letter from "../pages/admin/letters/Letters";
import AddLetter from "../pages/admin/letters/AddLetter";
import AddLeaflet from "../pages/admin/letters/AddLeaflet";
import Letterhead from "../pages/admin/letters/Letterhead";
import LetterCodeAdmin from "../pages/admin/letters/LetterCode";
import RequstedLetters from "../pages/admin/requstedLetters/RequstedLetters";
import DetailLetters from "../pages/admin/requstedLetters/DetailLetters";
import Settings from "pages/admin/settings/Settings";
import Leaflet from "pages/admin/leaflet/Leaflet";
import CreateLeaflet from "pages/admin/leaflet/CreateLeaflet";
import Report from "pages/admin/report/Report";
import LetterCode from "pages/admin/lettercode/lettercode";

const routes = [
  {
    path: "/admin",
    component: Dashboard,
    exact: true,
    auth: ["admin", "operator", "prodi", "rb", "guest"],
  },
  {
    path: "/admin/users",
    component: Users,
    exact: true,
    auth: ["admin", "operator"],
  },
  {
    path: "/admin/master-surat",
    component: Letter,
    exact: true,
    auth: ["admin"],
  },
  {
    path: "/admin/master-surat/manage",
    component: AddLetter,
    exact: true,
    auth: ["admin"],
  },
  {
    path: "/admin/master-surat/manage/:id",
    component: AddLetter,
    exact: true,
    auth: ["admin"],
  },
  {
    path: "/admin/master-surat/kop-surat/:id",
    component: Letterhead,
    exact: true,
    auth: ["admin"],
  },
  {
    path: "/admin/master-surat/kode-surat/:id",
    component: LetterCodeAdmin,
    exact: true,
    auth: ["admin"],
  },
  {
    path: "/admin/master-surat/edaran/manage",
    component: AddLeaflet,
    exact: true,
    auth: ["admin"],
  },
  {
    path: "/admin/master-surat/edaran/manage/:id",
    component: AddLeaflet,
    exact: true,
    auth: ["admin"],
  },
  {
    path: "/admin/pengaturan",
    component: Settings,
    exact: true,
    auth: ["operator", "prodi", "admin"],
  },
  {
    path: "/admin/surat",
    component: RequstedLetters,
    exact: true,
    auth: ["admin", "operator", "prodi", "guest"],
  },
  {
    path: "/admin/surat/detail/:id",
    component: DetailLetters,
    exact: true,
    auth: ["admin", "operator", "prodi", "guest"],
  },
  {
    path: "/admin/edaran",
    component: Leaflet,
    exact: true,
    auth: ["admin", "operator"],
  },
  {
    path: "/admin/edaran/buat-edaran/:id",
    component: CreateLeaflet,
    exact: true,
    auth: ["admin", "operator"],
  },
  {
    path: "/admin/laporan",
    component: Report,
    exact: true,
    auth: ["operator"],
  },
  {
    path: "/admin/nomor-surat",
    component: LetterCode,
    exact: true,
    auth: ["operator", "prodi", "admin"],
  },
];

export default routes;
